export class SsnNotUniqError extends Error {
  constructor(message: string) {
    super(message);
  }
}
